__turbopack_context__.v({
  "block-sender-wrapper": "PhoneWelcomeView-module-scss-module__lnmzaq__block-sender-wrapper",
  "dashboard-btn": "PhoneWelcomeView-module-scss-module__lnmzaq__dashboard-btn",
  "demo-heading": "PhoneWelcomeView-module-scss-module__lnmzaq__demo-heading",
  "demo-img": "PhoneWelcomeView-module-scss-module__lnmzaq__demo-img",
  "demo-input": "PhoneWelcomeView-module-scss-module__lnmzaq__demo-input",
  "demo-input-wrapper": "PhoneWelcomeView-module-scss-module__lnmzaq__demo-input-wrapper",
  "demo-wrapper": "PhoneWelcomeView-module-scss-module__lnmzaq__demo-wrapper",
  "instruction-item": "PhoneWelcomeView-module-scss-module__lnmzaq__instruction-item",
  "main-heading": "PhoneWelcomeView-module-scss-module__lnmzaq__main-heading",
  "main-wrapper": "PhoneWelcomeView-module-scss-module__lnmzaq__main-wrapper",
  "phone-instructions-wrapper": "PhoneWelcomeView-module-scss-module__lnmzaq__phone-instructions-wrapper",
  "relay-contact-icon": "PhoneWelcomeView-module-scss-module__lnmzaq__relay-contact-icon",
  "welcome-text-cta": "PhoneWelcomeView-module-scss-module__lnmzaq__welcome-text-cta",
});
